import { Route } from '@angular/router';
import { AppVersionGuard } from '@luggagehero/services/app-version-guard.service';
import { RedirectGuard } from '@luggagehero/services/redirect-guard.service';
import { Config } from '@luggagehero/shared/environment';
import { googleMapsLoadedGuard } from '@luggagehero/shared/services/google-maps';
import { bookingsUrlMatcher } from '@luggagehero/shared/util';

// lazy loaded modules are handled here.
// users are handled in the module itself and then imported in the web.module
export const routes: Array<Route> = [
  {
    path: '',
    canActivate: [AppVersionGuard],
    children: [
      {
        path: 'login',
        loadChildren: () => import('../components/empty/empty.module').then((m) => m.EmptyLoaderModule),
      },
      {
        path: 'demo',
        canActivate: [googleMapsLoadedGuard],
        loadChildren: async () => (await import('@luggagehero/traveler/shops/routes')).travelerShopsRoutesRoutes,
      },
      // Bookings before shops, matched on its first segment: as two `path: ''` siblings, every /bookings URL
      // first downloaded the shops module and only then fell through to this one (AM-5110).
      {
        matcher: bookingsUrlMatcher,
        loadChildren: () => import('./bookings/bookings.module').then((m) => m.BookingsLoaderModule),
      },
      { path: '', loadChildren: () => import('./shops/shops.module').then((m) => m.ShopsLoaderModule) },
      {
        path: 'shop-manager',
        canActivate: [RedirectGuard],
        component: RedirectGuard,
        data: {
          externalUrl: () => Config.environment.DASHBOARD_UI,
        },
      },
      {
        path: 'storage-manager',
        canActivate: [RedirectGuard],
        component: RedirectGuard,
        data: {
          externalUrl: () => Config.environment.DASHBOARD_UI,
        },
      },
    ],
  },
];
